import { z } from "zod";

export const uploadDataPointsFilesForHomeChargingPayloadSchema = z.object({
  requestUuid: z.uuid(),
  from: z.iso.datetime(),
  to: z.iso.datetime(),
  vins: z.array(z.string()),
});

export type UploadDataPointsFilesForHomeChargingPayload = z.infer<
  typeof uploadDataPointsFilesForHomeChargingPayloadSchema
>;
